import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  IconButton,
  MenuItem,
  Modal,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { headingStyle } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import { primaryBtn } from "../../style/AppointmentStyle";
import Select from "react-select";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import UseGetMedicineList from "../../helper/UseGetMedicineList";
import { useLocation } from "react-router-dom";
import { autoFocusOffWithOutBorder } from "../../style/PatinetFormStyle";
import medicine_salt from "../../assets/medicine_salt.svg";
import useDebounce from "../../hooks/UseDebounce";
import UseFetchMedicineAdmin from "../../helper/UseFetchMedicineAdmin";
import { showToast } from "../../utils/toastUtil";
import {
  generateMedicineSalt,
  ExtractMedicineSummaryV1,
} from "../../connections/postApi";
import { putUpdateMedicineSalt } from "../../connections/putApi";
import { normalizeMedicineSalt } from "../../utils/medicineSaltUtils";


const EditMedicineSalt = ({ onClose, refetch }) => {
  // console.log(medicines);
  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [medicineSearchInput, setMedicineSearchInput] = useState(null);
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [autoFillLoading, setAutoFillLoading] = useState(false);
  const [nameError, setNameError] = useState("");

  const debouncedInputMedicine = useDebounce(medicineSearchInput, 1000);

  const { data: medicalTestDataList, isLoading } = UseFetchMedicineAdmin(
    page,
    itemPerPage,
    debouncedInputMedicine,
  );
  const [formattedMedicalTestOptions, setFormattedMedicalTestOptions] =
    useState([]);

  const location = useLocation();
  const saltDetails = location.state || null;

  const [formState, setFormState] = useState({
    name: saltDetails?.name || "",
    medicine: [],
  });
  useEffect(() => {
    setFormState({
      name: saltDetails?.name || "",
      medicine: saltDetails?.medicines?.map((item) => item?.id) || [],
    });
  }, [saltDetails]);
  console.log(formState, "formState");

  useEffect(() => {
    const newOptions = (medicalTestDataList?.payload?.medicines || []).map(
      (medicine) => ({
        value: medicine?.id,
        label: medicine?.name,
      }),
    );

    const preFilledMedicine = (saltDetails?.medicines || []).map(
      (medicine) => ({
        value: medicine?.id,
        label: medicine?.name,
      }),
    );

    console.log(preFilledMedicine, "preFilledMedicine");
    console.log(newOptions, "newOptions");

    // setFormattedMedicalTestOptions((prevOptions) => [...prevOptions, ...newOptions]);
    setFormattedMedicalTestOptions((prevOptions) => {
      // Create a Map to filter out duplicates based on 'value' (medicine.id)
      const mergedOptions = [
        ...prevOptions,
        ...preFilledMedicine,
        ...newOptions,
      ];
      const uniqueOptions = Array.from(
        new Map(mergedOptions.map((item) => [item.value, item])).values(),
      );

      return uniqueOptions;
    });
  }, [medicalTestDataList, saltDetails]);

  console.log(formattedMedicalTestOptions);
  const handleChange = (name, value) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "name") setNameError("");
  };

  const handleAutoFillName = async () => {
    if (!formState.medicine?.length) {
      showToast("Select at least one medicine to auto-fill", "ERROR");
      return;
    }
    const labels = formState.medicine.map(
      (id) =>
        formattedMedicalTestOptions.find((opt) => opt.value === id)?.label ??
        "",
    );
    setAutoFillLoading(true);
    try {
      const res = await ExtractMedicineSummaryV1(
        "",
        "medicine_salt",
        "GlobalAiContext",
        null,
        null,
        labels,
      );
      const salts = res?.payload?.summaries?.medicines
        ?.map((m) => m?.salt)
        .filter(Boolean);
      const salt = salts?.join(" + ") || null;
      if (salt) {
        handleChange("name", normalizeMedicineSalt(salt));
      } else {
        showToast("Could not determine salt. Please enter manually.", "ERROR");
      }
    } catch {
      showToast("Failed to auto-fill salt", "ERROR");
    } finally {
      setAutoFillLoading(false);
    }
  };

  const handleSaltUpdate = async (e) => {
    e.preventDefault();

    if (!formState?.name?.trim()) {
      setNameError("Medicine salt name is required.");
      return;
    }

    setLoading(true);
    const payload = {
      medicine_salt: { name: formState?.name },
      medicines_ids: formState?.medicine,
    };
    try {
      const result = await putUpdateMedicineSalt(payload, saltDetails?.id);
      // console.log(result);
      showToast(
        result?.status?.message || result?.status?.status,
        result?.status?.status,
      );
      if (result?.status?.status === "SUCCESS") {
        setLoading(false);
        if (refetch()) {
          refetch();
        }
        onClose();
      }
    } catch (error) {
      showToast(error.message, "ERROR");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* //modals for delete and filter */}
        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          sx={{
            position: "absolute",
            top: "25%",
            width: "450px",
            margin: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: 3.6,
              boxShadow: 24,
              p: 4.5,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography textAlign={"center"}>Are you sure?</Typography>
              <Typography textAlign={"center"}>
                You want to delete these selected purchase orders?
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "flex",
                gap: "25px",
                width: "max-content",
                margin: "auto",
                marginTop: "40px",
              }}
            >
              <Button
                sx={{
                  backgroundColor: "#FF392B",
                  color: "white",
                  border: "",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "red",
                  },
                }}
              >
                Delete
              </Button>
              <Button
                onClick={() => setDeleteModal(false)}
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  border: "2px solid #FF392B",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={filterModal}
          onClose={() => setFilterModal(false)}
          sx={{
            position: "absolute",
            top: "14%",
            // left:'50%',
            width: "340px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: "20px",
              boxShadow: 24,
              p: 1,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Grid container spacing={2} sx={{ padding: "9px" }}>
              <Grid item xs={12}>
                <Typography
                  variant="subTitle116px"
                  fontWeight={"600"}
                  textAlign={"center"}
                  margin={"auto"}
                >
                  Filters
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Select
                  fullWidth
                  defaultValue=""
                  placeholder="Select Filter"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "#F7F7FF",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "text.default_grey" }}>
                          Select filter
                        </span>
                      );
                    }
                    return selected === "filter1"
                      ? "filter2"
                      : selected === "filter3"
                        ? "filter3"
                        : "select filter";
                  }}
                >
                  <MenuItem value="filter1">Filter 1</MenuItem>
                  <MenuItem value="filter2">Filter 2</MenuItem>
                  <MenuItem value="filter3">Filter 3</MenuItem>
                </Select>
              </Grid>

              {/* Purchase Date */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Purchase Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Department Selection */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Department</Typography>
                <Select
                  fullWidth
                  defaultValue=""
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "#F7F7FF",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <MenuItem value="dept1">Department 1</MenuItem>
                  <MenuItem value="dept2">Department 2</MenuItem>
                  <MenuItem value="dept3">Department 3</MenuItem>
                </Select>
              </Grid>

              {/* Created At */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Created At</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Buttons */}
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtnTeal, color: "white" }}
                >
                  Apply
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => setFilterModal(false)}
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtn, color: "white", border: "none" }}
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <img
                src={medicine_salt}
                alt=""
                style={{ width: "28px", height: "28px", display: "block" }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={{ ...headingStyle, mb: 0 }}
              >
                Edit Medicine salt
              </Typography>
            </Box>
            <IconButton sx={{ marginBottom: "1rem" }} onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            position="sticky"
            width="96%"
            gap="60px"
            margin="auto"
            marginBottom="30px"
          >
            <Typography sx={{ mt: 1.2 }}> Name </Typography>
            <Box sx={{ flexGrow: 1 }}>
              <Box display="flex" alignItems="center" gap="8px">
                <TextField
                  placeholder="e.g. PARACETAMOL 500 MG"
                  value={formState?.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                  fullWidth
                  sx={{
                    ...autoFocusOffWithOutBorder,
                    ...(nameError && {
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "red" },
                        padding: "9px",
                        borderRadius: "8px",
                        border: "2px",
                        backgroundColor: "neutral.white",
                      },
                    }),
                  }}
                />
                <Tooltip
                  title={
                    formState.medicine?.length
                      ? "Get medicine salt suggestion from AI"
                      : "Select medicines first to auto-fill"
                  }
                  placement="top"
                >
                  <span>
                    <IconButton
                      onClick={handleAutoFillName}
                      disabled={!formState.medicine?.length || autoFillLoading}
                      sx={{
                        color: formState.medicine?.length
                          ? "#2e7d32"
                          : "action.disabled",
                        "&:hover": { backgroundColor: "#e0f4f7", color: "#0097B2" },
                      }}
                    >
                      {autoFillLoading ? (
                        <CircularProgress size={16} sx={{ color: "#2e7d32" }} />
                      ) : (
                        <AutoFixHighIcon fontSize="small" />
                      )}
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
              {nameError && (
                <Typography
                  variant="caption"
                  sx={{ color: "red", mt: 0.5, display: "block", pl: 0.5 }}
                >
                  {nameError}
                </Typography>
              )}
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
            // paddingX="25px"
            width="96%"
            gap="30px"
            margin="auto"
            marginBottom="30px"
            sx={{ zIndex: 99999 }}
            item
            sm={3}
          >
            <Typography> Medicines </Typography>

            <Select
              options={formattedMedicalTestOptions}
              value={formState?.medicine?.map((test) => ({
                value: test,
                label: formattedMedicalTestOptions.find(
                  (option) => option.value === test,
                )?.label,
              }))}
              isMulti
              isSearchable
              placeholder=" Medicine "
              className="react-select"
              classNamePrefix="select"
              onInputChange={(value) => {
                setMedicineSearchInput(value);
              }}
              onChange={(selectedOptions) => {
                // Convert selectedOptions to an array of values
                const selectedValues = Array.isArray(selectedOptions)
                  ? selectedOptions.map((option) => option.value)
                  : [];
                handleChange("medicine", selectedValues); // Update formState with values only
              }}
              styles={{
                width: "100%",
                backgroundColor: "neutral.white",
                flexGrow: 1,
                container: (provided) => ({
                  ...provided,
                  flexGrow: 1, // Take up the remaining space
                }),
                // Menu z-index to avoid overlap issues
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999999,
                  fontFamily: "Outfit",
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 999999,
                }),
                // Control styles for the Select input box
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: state.isFocused
                    ? "#2e37a4"
                    : "rgba(46, 55, 164, 0.1)",
                  boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
                  // "&:hover": {
                  //   borderColor: "#2e37a4",
                  // },
                  backgroundColor: "neutral.white",
                  borderRadius: "15px",
                  fontSize: "14px",
                  width: "100%",
                  minHeight: "45px",
                  zIndex: 999999,
                  fontFamily: "Outfit",
                }),
                // Dropdown indicator for animation and styling
                dropdownIndicator: (base, state) => ({
                  ...base,
                  fontFamily: "Lato",
                  transform: state.selectProps.menuIsOpen
                    ? "rotate(-180deg)"
                    : "rotate(0)",
                  transition: "transform 250ms ease",
                  // width: "35px",
                  // height: "35px",
                }),
              }}
              menuPortalTarget={document.body}
            />
          </Box>
        </Box>

        <Box
          container
          display={"flex"}
          justifyContent={"space-between"}
          sx={{ zIndex: "10" }}
          lg={12}
          marginBottom={"5px"}
        >
          <Grid item></Grid>
          <Grid item>
            <Button
              className="btn draw-border"
              variant="contained"
              id="submit"
              sx={{
                ...primaryBtnTeal,
                width: "195px",
                display: "flex",

                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={handleSaltUpdate}
              disabled={loading}
            >
              <Typography
                textTransform={"capitalize"}
                color={"neutral.white"}
                variant="title1_medium"
              >
                Update Medicine Salt
              </Typography>
            </Button>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default EditMedicineSalt;
